module.exports = "<p>\n  load-window works!\n</p>\n"